import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Link as ChakraLink, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import {termsPrivacyInfo, termsPrivacyInfoLink} from '../index.style'
import {iconStyle} from '../../../components/order-summary/index.style'
import {
    AmexIcon,
    DiscoverIcon,
    MastercardIcon,
    PaypalIcon,
    VisaIcon
} from '../../../components/icons'

const TermsAndConditions = () => {
    return (
        <>
            <Text sx={termsPrivacyInfo}>
                <FormattedMessage
                    id="register_form.message.terms_privacy_info_checkout_page"
                    defaultMessage="By clicking Place Order, you are agreeing to our <terms>Terms and Conditions</terms>, <policy>Privacy Policy</policy>, and <return>Return Policy</return>."
                    values={{
                        policy: (chunks) => (
                            <ChakraLink
                                as={Link}
                                to="/content/privacy-policy.html"
                                sx={termsPrivacyInfoLink}
                                isExternal
                                target="_blank"
                            >
                                {chunks}
                            </ChakraLink>
                        ),
                        terms: (chunks) => (
                            <ChakraLink
                                as={Link}
                                to="/content/terms.html"
                                sx={termsPrivacyInfoLink}
                                isExternal
                                target="_blank"
                            >
                                {chunks}
                            </ChakraLink>
                        ),
                        return: (chunks) => (
                            <ChakraLink
                                as={Link}
                                to="/content/returns-exchanges.html"
                                sx={termsPrivacyInfoLink}
                                isExternal
                                target="_blank"
                            >
                                {chunks}
                            </ChakraLink>
                        )
                    }}
                />
            </Text>
            <Flex justify={'center'} sx={iconStyle}>
                <VisaIcon height={8} width={10} mr={2} />
                <MastercardIcon height={8} width={10} mr={2} />
                <AmexIcon height={8} width={10} mr={2} />
                <DiscoverIcon height={8} width={10} mr={2} />
                <PaypalIcon height={8} width={10} mr={2} />
            </Flex>
        </>
    )
}

export default TermsAndConditions
